import styled from "@emotion/styled";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MUIListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

const ListItemButton = styled(MUIListItemButton)`
  padding: 0 2px;
`;

export default function ListItem({ element, ...props }) {
	return (
		<ListItemButton
			onClick={() => props.onClick(element)}
			key={props.key}
			data-test-id="filter-list-item"
		>
			<ListItemIcon>
				<Checkbox
					edge="start"
					checked={props.isChecked}
					tabIndex={-1}
					disableRipple
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						props.onSelect(element);
					}}
					indeterminate={props.isIndeterminate}
					data-test-id="filter-list-checkbox"
				/>
			</ListItemIcon>
			<ListItemText
				primary={<span className="size-16-light">{props.text}</span>}
			/>
			{props.isExpandedList && (props.isOpen ? <ExpandLess /> : <ExpandMore />)}
		</ListItemButton>
	);
}
